module.exports = __webpack_public_path__ + "static/media/AllGiftsRegistry.cc338553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/AllGiftsRegistry.png
// module id = 722
// module chunks = 51